export default __webpack_public_path__ + "76d578cf7c9dd50cca01172084eb88e8.png";